import React from "react";
import Layout from "../../components/Layout";
import ScrollToTop from "../../components/ScrollToTop";
import SessionCheck from "../../components/SessionCheck";
import NavHeader from "../../components/NavHeader";
import SmartHomesReceipt from "../../sections/SmartHome/SmartHomesReceipt";

const ReceiptSmartHomes = () => {
  return (
    <Layout>
      <ScrollToTop />
      <SessionCheck shouldRedirect />
      <NavHeader
        pageTitle="Smart Home Services"
        routeName="Smart Home Services"
      />
      <SmartHomesReceipt />
    </Layout>
  );
};

export default ReceiptSmartHomes;
